const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  roles: state => state.user.roles,
  studentListCardData: state => state.user.studentListCardData,
  interveneObj: state => state.user.interveneObj,
  isShowJieRu: state => state.user.isShowJieRu,
  currentViewStudent: state => state.user.currentViewStudent,
  isCutDown: state => state.user.isCutDown,
  messageListData: state => state.user.messageListData,
  studentList: state => state.user.studentList,
  studentReportList: state => state.user.studentReportList,
  pageStudentCard: state => state.user.pageStudentCard,
  currentUserId: state => state.user.currentUserId,
  leftStudentCount: state => state.user.leftStudentCount,
  initWaitQuestionsList: state => state.user.initWaitQuestionsList,
  cachedMsg: state => state.user.cachedMsg,
  questionIdNum: state => state.user.questionIdNum,
  myStudentList: state => state.user.myStudentList,
  studentMessageList: state => state.user.studentMessageList,
  messageBusList: state => state.user.messageBusList,
  studentListCard: state => state.user.studentListCard,
  isCloseLeft: state => state.user.isCloseLeft,
  systemTime: state => state.user.systemTime,
  language: state => state.app.language,
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js